<template>
  <div>
    <v-dialog v-model="dialog" persistent max-width="290">
      <v-card>
        <v-card-title class="headline">
          {{ selectedItem.productName }}
        </v-card-title>
        <v-card-text>
          <v-btn @click="subtractQty">-</v-btn>
          {{ selectedItemQty }}
          <v-btn @click="addQty">+</v-btn>
        </v-card-text>
        <v-card-actions>
          <v-btn color="red darken-1" text @click="dialog = false"
            >Cancel</v-btn
          >
          <v-spacer></v-spacer>
          <v-btn color="green darken-1" text @click="process">Process</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-simple-table :fixed-header="fixedHeader">
      <template v-slot:default>
        <thead>
          <tr>
            <th class="text-left">Product Name</th>
            <th class="text-left">Order Date</th>
            <th class="text-left">Quantity</th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="item in filteredItems"
            :key="item.itemId"
            @click="clicked(item.itemId)"
          >
            <td>{{ item.productName }}</td>
            <td>{{ item.purchase.dateOrdered.date.slice(0, 10) }}</td>
            <td>{{ item.qty - item.qtyDelivered - item.qtyCanceled }}</td>
          </tr>
        </tbody>
      </template>
    </v-simple-table>
  </div>
</template>

<script>
//import axios from "axios";
import { mapGetters } from "vuex";

export default {
  name: "Expected",
  data() {
    return {
      selectedItem: "",
      selectedItemQty: 0,
      fixedHeader: true,
      dialog: false
      // items: []
    };
  },
  props: ["search"],
  methods: {
    menuClicked() {
      console.log("op hamburger geklikt");
      this.$emit("menuClicked");
    },
    clicked(id) {
      this.selectedItem = this.$store.getters.getItemById(id);
      this.selectedItemQty =
        this.selectedItem.qty -
        this.selectedItem.qtyDelivered -
        this.selectedItem.qtyCanceled;
      this.dialog = true;
    },
    subtractQty() {
      if (this.selectedItemQty > 1) {
        this.selectedItemQty--;
      }
    },
    addQty() {
      if (
        this.selectedItemQty <
        this.selectedItem.qty -
          this.selectedItem.qtyDelivered -
          this.selectedItem.qtyCanceled
      ) {
        this.selectedItemQty++;
      }
    },
    process() {
      this.dialog = false;
      this.$store
        .dispatch("processExpected", {
          itemId: this.selectedItem.itemId,
          qty: this.selectedItemQty
        })
        .catch(err => {
          console.log(err.response);
        });
      console.log(
        "Item id: " +
          this.selectedItem.itemId +
          ", Quantity: " +
          this.selectedItemQty
      );
      this.selectedItem = "";
      this.selectedItemQty = 0;
    },
    cancel() {
      this.dialog = false;
      this.selectedItem = "";
      this.selectedItemQty = 0;
    }
  },
  computed: {
    ...mapGetters(["getExpected"]),
    sortedArray() {
      function compare(a, b) {
        if (a.purchase.dateOrdered.date < b.purchase.dateOrdered.date)
          return -1;
        if (a.purchase.dateOrdered.date > b.purchase.dateOrdered.date) return 1;
        return 0;
      }
      if (this.getExpected) {
        let result = this.getExpected;

        result = result.sort(compare);
        return result;
      }
      return [];
    },
    filteredItems: function() {
      return this.sortedArray.filter(item => {
        return item.productName.toLowerCase().match(this.search.toLowerCase());
      });
    }
  },
  created: function() {
    this.$store.dispatch("getExpectedFromServer").catch(err => {
      console.log(err.response);
    });
  }
};
</script>
